function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "creditcard-b",
  x1: "0%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#060B0E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#254764"
})), /*#__PURE__*/React.createElement("rect", {
  id: "creditcard-a",
  width: 32,
  height: 32,
  rx: 8
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "creditcard-c",
  x1: "27.635%",
  x2: "22.59%",
  y1: "25.476%",
  y2: "11.652%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "creditcard-e",
  x1: "50%",
  x2: "38.943%",
  y1: "100%",
  y2: "55.528%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "creditcard-f",
  x1: "38.943%",
  x2: "50%",
  y1: "55.528%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "creditcard-i",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FAD961"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F7955D"
})), /*#__PURE__*/React.createElement("rect", {
  id: "creditcard-h",
  width: 7,
  height: 5,
  rx: 1
}), /*#__PURE__*/React.createElement("filter", {
  id: "creditcard-g",
  width: "157.1%",
  height: "180%",
  x: "-28.6%",
  y: "-20%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "creditcard-d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#creditcard-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#creditcard-b)",
  xlinkHref: "#creditcard-a"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 40.5,
  r: 31.5,
  fill: "url(#creditcard-c)",
  mask: "url(#creditcard-d)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 31.5,
  r: 16.5,
  fill: "url(#creditcard-e)",
  mask: "url(#creditcard-d)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42.5,
  cy: -1.5,
  r: 26.5,
  fill: "url(#creditcard-f)",
  mask: "url(#creditcard-d)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#creditcard-d)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 14)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#creditcard-g)",
  xlinkHref: "#creditcard-h"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#creditcard-i)",
  xlinkHref: "#creditcard-h"
})), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 3,
  x: 1,
  y: 1,
  fill: "#7A3802",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 3,
  x: 3,
  y: 1,
  fill: "#7A3802",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 3,
  x: 5,
  y: 1,
  fill: "#7A3802",
  opacity: 0.3
}))), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 1,
  x: 4,
  y: 22,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1,
  x: 4,
  y: 24,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1,
  x: 8,
  y: 24,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1,
  x: 12,
  y: 24,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 1,
  x: 10,
  y: 22,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 1,
  x: 16,
  y: 22,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 1,
  x: 22,
  y: 22,
  fill: "#FFF",
  fillOpacity: 0.8,
  mask: "url(#creditcard-d)"
}));

var SvgCreditcard = function SvgCreditcard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditcard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creditcard.e32ed5a7.svg";
export { ForwardRef as ReactComponent };